export default __webpack_public_path__ + "static/media/pic3.b4e967bf.jpg";